// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgotPassword`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    dashboards: {
      smartSensing: {
        list: `${ROOTS.DASHBOARD}/smartSensing/`,
      },
      visitantes: {
        list: `${ROOTS.DASHBOARD}/analisisVisitantes/`,
      },
      visitas: {
        list: `${ROOTS.DASHBOARD}/analisisVisitas/`,
      },
      mapaCalor: {
        list: `${ROOTS.DASHBOARD}/mapaCalor/`,
      },
    },
    configuration: {
      user: {
        new: `${ROOTS.DASHBOARD}/users/new`,
        list: `${ROOTS.DASHBOARD}/users`,
      },
      roles: {
        new: `${ROOTS.DASHBOARD}/roles/new`,
        list: `${ROOTS.DASHBOARD}/roles`,
      },
      relationRolService: {
        list: `${ROOTS.DASHBOARD}/ServicioRol`,
      },
      branches: {
        list: `${ROOTS.DASHBOARD}/sucursales`,
        new: `${ROOTS.DASHBOARD}/sucursales/new`,
      },
      companies: {
        list: `${ROOTS.DASHBOARD}/empresas`,
        new: `${ROOTS.DASHBOARD}/empresas/new`,
      },
      device: {
        new: `${ROOTS.DASHBOARD}/dispositivos/new`,
        list: `${ROOTS.DASHBOARD}/dispositivos`,
      },
      advertising: {
        list: `${ROOTS.DASHBOARD}/publicidad`,
        new: `${ROOTS.DASHBOARD}/publicidad/new`,
      },
    },
    process: {
      scheduler: `${ROOTS.DASHBOARD}/schedulerReportes`,
      sensorsMonitor: `${ROOTS.DASHBOARD}/monitoreoSensores`,
    },
  },
};
